import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export interface ReimportRequisitionRequest {
    orderId: string;
}

export const reimportRequisition = async (request: ReimportRequisitionRequest): Promise<void> => {
    return await authorizedAxiosInstance.post(`/cfm/triggers/reimport-requisition/${request.orderId}`);
};
